import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import de from './de.json';
import en from './en.json';

const supportedLanguages = ['de', 'en'];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: {
            order: ['querystring', 'localStorage', 'navigator'],
        },
        resources: {
            de: { translations: de },
            en: { translations: en },
        },
        supportedLngs: supportedLanguages,
        fallbackLng: 'de',
        debug: true,
        ns: ['translations'],
        defaultNS: 'translations',
        interpolation: {
            escapeValue: false,
        },
    });

export const persistLanguage = (language: string): void => {
    if (!supportedLanguages.includes(language)) {
        return;
    }

    localStorage.setItem('i18nextLng', language);
};
export function getCurrentLang(): string {
    const langCode = i18n.language.slice(0, 2).toLowerCase();
    return supportedLanguages.includes(langCode) ? langCode : 'de';
}

export default i18n;
